<template>
  <div>
    
    <div class="search">
      <input
        id="search-bar"
        v-model="search"
        class="search-field"
        type="text"
        placeholder="Filter by agency name, address, or specialty"
      />
      <input ref="archive-search-bar" type="submit" class="search-submit" value="Search" />
      <button v-if="search.length > 0" class="clear-search-btn" @click="clearSearchBar">
        <i class="fas fa-times" />
      </button>
    </div>
    <div v-show="loading" class="mtm center">
      <i class="fas fa-spinner fa-spin fa-3x" />
    </div>
    <div v-show="!loading && empty" class="h3 mtm center">Sorry, there are no results.</div>
    <div v-show="failure" class="h3 mtm center">Sorry, there was a problem. Please try again.</div>
    <table v-show="!empty && !loading && !failure">
      <thead>
        <tr>
          <th  class="agency table-sort title" :class="currentSortDir" @click="toggleSort()">
            <span>Agency</span>
          </th>
          <th class="address">Address</th>
          <th class="address">Phone number</th>
          <th class="hca">Housing counseling</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="site in filteredResources" :key="site.ObjectID">
          <td> <a target="_blank" class="external" :href="'http://' + site.WEBSITE_URL"> {{site.AGENCY }}</a></td>
          <td>{{ site.STREET_ADDRESS }}, {{ site.ZIP_CODE}}</td>
          <td>{{ site.PHONE_NUMBER }}</td>
          <td>{{ site.SPECIALTY | toSentenceCase }}<span v-if="site.FORECLOSURE && (site.SPECIALTY !== ' ' && site.SPECIALTY !== null)">, Foreclosure</span><span v-if="site.FORECLOSURE && (site.SPECIALTY == ' ' || !site.SPECIALTY)">Foreclosure</span><span v-if="site.PRE_PURCHASE && site.FORECLOSURE">, Pre-purchase</span><span v-if="site.PRE_PURCHASE && !site.FORECLOSURE">Pre-purchase</span></td>
          <!-- <td>{{site.NAC | filterNAC }}</td><td>{{site.NEC | filterNEC }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import VueFuse from "vue-fuse";
import Vue from "vue";

const endpoint = "https://services.arcgis.com/fLeGjb7u4uXqeF9q/arcgis/rest/services/NeighborhoodResources/FeatureServer/0/query?where=1%3D1&outFields=*&f=pjson";

Vue.use(VueFuse);

export default {
  name: "HCATable",
  data: function() {
    return {
      neighborhoodResources: [],
      filteredResources: [],
      search: "",
      loading: false,
      failure: false,
      empty: false,
      currentSortDir: "desc",
      searchOptions: {
        shouldSort: true,
        threshold: 0.1,
        tokenize: true,
        keys: ["AGENCY", "STREET_ADDRESS", "ZIP_CODE", "SPECIALTY", 'specialties']
      }
    };
  },

  mounted() {
    this.fetchData();
  },

  filters: {
    filterNAC: function(val) {
      return (val === "Yes" ? "NAC" : "")
    },

    filterNEC: function(val) {
      return (val === "Yes" ? "NEC" : "")
    },

    toSentenceCase: function(val) {
      if (val) {
      return val.replace(
            /\w\S*/g,
            function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            }
        );
      }
      return ""
    },
  },

  watch: {
    search() {
      this.searchTable();
    },
    filteredResources() {
      if (!this.failure) {
        if (this.filteredResources.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
      }
    }
  },

  methods: {
    fetchData: function() {
      this.loading = true;
      axios
        .get(endpoint)
        .then(response => {
          response.data.features.forEach(item => {
            item.attributes["specialties"] = [];
            if (item.attributes.HCA == 'Yes') {
              item.attributes["specialties"].push("HCA Housing Counseling");
              this.neighborhoodResources.push(item.attributes);
              this.filteredResources.push(item.attributes);
            }
    
          });
          this.sortSites();
          this.failure = false;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.failure = true;
        });
    },

    toggleSort: function() {
      this.currentSortDir = this.currentSortDir === "asc" ? "desc" : "asc";
      this.sortSites();
    },

    sortSites: function() {
      this.filteredResources.sort((a, b) => {
        let modifier = -1;
        if (this.currentSortDir === "desc") {
          modifier = 1;
        }
        var textA = a.AGENCY.toUpperCase();
        var textB = b.AGENCY.toUpperCase();
        return textA < textB ? -1 * modifier : textA > textB ? 1 * modifier : 0;
      });
    },

    clearSearchBar: function() {
      this.search = "";
    },

    searchTable: function() {
      if (this.search) {
        this.$search(this.search, this.neighborhoodResources, this.searchOptions).then(
          sites => {
            this.filteredResources = sites;
          }
        );
      } else {
        this.filteredResources = this.neighborhoodResources;
        this.sortSites();
      }
    }
  }
};
</script>

<style scoped>
.clear-search-btn {
  position: absolute;
  top: 16px;
  right: 70px;
  padding: 0;
  font-size: 20px;
  background-color: #fff;
  opacity: 0.8;
  z-index: 999;
  cursor: pointer;
  color: rgba(60, 60, 60, 0.5);
}

.hca {
  width: 25%
}
.nac, .nec{
  width: 10%
}

.agency {
  width: 35%;
}
 .address {
  width: 20%
}
</style>
